export default __webpack_public_path__ + "static/media/explainer_lightning@2x.e53a7ddb.png";